import React, { useState } from 'react';
import classes from './WriteComment.module.css';
import MyButton from '../MyButton/MyButton';
import { createTherapyComment } from '../../../API/therapyApi';

const WriteComment = ({ therapyId, setWriteCommentVisible }) => {
    const [comment, setComment] = useState('');

    const addComment = async () => {
        try {
            const commentData = createTherapyComment(therapyId, comment)
            setWriteCommentVisible(false);
        } catch (e) {
            console.log(e);
            alert(e.response.data.error);
        }
    };

    return (
        <div className={classes.writeComment}>
            <div className={classes.header}>Введите комментарий</div>
            <textarea
                className={classes.textareaInput}
                value={comment}
                onChange={(e) => setComment(e.target.value)}
            />
            <div className={classes.btns}>
                <MyButton
                    onClick={() => {
                        setWriteCommentVisible(false);
                        setComment('')
                    }}
                >
                    Отмена
                </MyButton>
                <MyButton
                    onClick={addComment}
                >
                    Готово
                </MyButton>
            </div>
        </div>
    );
};

export default WriteComment;

